// src/service/UserService.js
import { SERVER_URL } from "../components/lib/constants";

class UserService {
  static BASE_URL = SERVER_URL;

  // // Auth is true only after OTP success (manual) or confirmed Google login
  // static isAuthenticated() {
  //   return (
  //     !!localStorage.getItem("applicationId") &&
  //     localStorage.getItem("sessionVerified") === "1"
  //   );
  // }

  static isAuthenticated() {
    const userId = localStorage.getItem("userId");
    const sessionVerified = localStorage.getItem("sessionVerified");
    const loginTime = localStorage.getItem("loginTime");

    if (!userId || sessionVerified !== "1" || !loginTime) {
      return false;
    }

    const now = new Date().getTime();
    const twelveHours = 12 * 60 * 60 * 1000;

    // ⛔ Expired session
    if (now - Number(loginTime) > twelveHours) {
      this.logout();
      return false;
    }

    return true;
  }

  // Helper to store pre-OTP details (manual login/register)
  static setPendingApplicant({
    email,
    firstname,
    lastname,
    middlename,
    picture,
  }) {
    if (email) localStorage.setItem("applicantEmail", email);
    if (firstname) localStorage.setItem("applicantFirstname", firstname);
    if (lastname) localStorage.setItem("applicantLastname", lastname);
    if (middlename !== undefined)
      localStorage.setItem("applicantMiddlename", middlename || "");
    localStorage.setItem("applicantPicture", picture || "/default-avatar.png");
  }

  // Finalize login after OTP or confirmed Google login
  // method: "manual" | "google"
  // providerId: for google = decoded.sub, for manual = email (OK to use email)
  static loginApplicant({
    email,
    firstname = "",
    lastname = "",
    middlename = "",
    picture = "/default-avatar.png",
    method = "manual",
    providerId,
  }) {
    const appId =
      method === "google"
        ? `google_${providerId}`
        : `manual_${email || providerId}`;

    localStorage.setItem("applicationId", appId);
    localStorage.setItem("applicantEmail", email || "");
    localStorage.setItem("applicantFirstname", firstname || "");
    localStorage.setItem("applicantLastname", lastname || "");
    localStorage.setItem("applicantMiddlename", middlename || "");
    localStorage.setItem("applicantPicture", picture || "/default-avatar.png");

    // mark as authenticated
    localStorage.setItem("sessionVerified", "1");

    return appId;
  }

  static getApplicant() {
    const email = localStorage.getItem("applicantEmail");
    const firstname = localStorage.getItem("applicantFirstname");
    const lastname = localStorage.getItem("applicantLastname");
    const middlename = localStorage.getItem("applicantMiddlename") || "";
    const picture =
      localStorage.getItem("applicantPicture") || "/default-avatar.png";
    const applicationId = localStorage.getItem("applicationId");
    return { email, firstname, lastname, middlename, picture, applicationId };
  }

  static logout() {
    localStorage.removeItem("applicationId");
    localStorage.removeItem("sessionVerified");
    localStorage.removeItem("applicantEmail");
    localStorage.removeItem("applicantFirstname");
    localStorage.removeItem("applicantLastname");
    localStorage.removeItem("applicantMiddlename");
    localStorage.removeItem("applicantPicture");

    // cleanup pending items too
    localStorage.removeItem("pendingOtpHashed");
    localStorage.removeItem("pendingUserData");
    localStorage.removeItem("pendingEmail");
  }
}

export default UserService;
